import { Avatar, Grid } from '@mui/material';
import { CardValue, AlertObjectProps } from '../../../../types/index'
import axios from 'axios'
import { useRecoilValue, useRecoilState } from 'recoil'
import { facturenStatusState, alertObjState } from '../../../../store/store'

const FacturenCard = ({ cardValue }: { cardValue: CardValue }) => {
    const facturenStatus = useRecoilValue(facturenStatusState)
    const [, setAlertObj] = useRecoilState<AlertObjectProps>(alertObjState)
    const disabled = facturenStatus.inProgress

    const handleClick = async () => {
        if (disabled) return // extra guard - the card is already visually disabled while a run is in progress

        // Immediate feedback that the click actually did something - the
        // call below stays open until the whole run finishes, which can
        // take a long time, so without this the user gets no confirmation
        // at all until it's fully done.
        setAlertObj({ message: `Facturen samenvoegen voor ${cardValue.name} gestart. Volg de voortgang hieronder.`, severity: 'info' })

        try {
            // Goes through the Portal's own backend, which adds the real
            // invoice-merger secret server-side. The browser never sees it -
            // that used to be hardcoded here directly, which leaked it to
            // anyone viewing the page source.
            const response = await axios.post('/api/facturen/start', { target: cardValue.link })
            const total = response.data?.totalInvoices ?? 0
            const successful = response.data?.successfulInvoices ?? 0
            const failed = response.data?.failedInvoices ?? 0

            if (total === 0) {
                setAlertObj({ message: `Geen facturen samen te voegen voor ${cardValue.name}.`, severity: 'info' })
            } else if (failed > 0) {
                setAlertObj({ message: `Facturen samenvoegen voor ${cardValue.name} is voltooid. ${successful}/${total} facturen verwerkt, ${failed} mislukt.`, severity: 'warning' })
            } else {
                setAlertObj({ message: `Facturen samenvoegen voor ${cardValue.name} is voltooid. ${successful}/${total} facturen verwerkt.`, severity: 'success' })
            }
        } catch (error: any) {
            // A 409 here means someone else's click won the race in the brief
            // window before the shared status caught up - rare now that the
            // card disables itself, but still handled explicitly rather than
            // only logged, so the user actually sees why nothing happened.
            const status = error?.response?.status
            const message =
                status === 409
                    ? 'Er loopt al een samenvoeging. Probeer het straks opnieuw.'
                    : error?.response?.data?.error ?? 'Er ging iets mis bij het starten van het samenvoegen.'
            setAlertObj({ message, severity: 'error' })
            console.error('Facturen samenvoegen mislukt:', error);
        }
    };

    return (
        <Grid item xs={4} sm={4} md={4} style={{ paddingTop: '1rem', paddingRight: '1rem', paddingBottom: '1rem', minWidth: "250px" }} >
            <a
                href="javascript:void(0)"
                onClick={handleClick}
                aria-disabled={disabled}
                style={{
                    textDecoration: "none",
                    color: "black",
                    cursor: disabled ? "not-allowed" : "pointer",
                    pointerEvents: disabled ? "none" : "auto",
                }}
            >
                <Grid
                    key={cardValue?.id}
                    container
                    textAlign="center"
                    alignItems="center"
                    justifyContent="center"
                    columns={{ xs: 4, sm: 8, md: 12 }}
                    style={{
                        border: "1px solid rgba(89, 89, 89, 0.5)",
                        borderLeft: '5px solid #11545A',
                        background: disabled ? '#f0f0f0' : 'white',
                        borderRadius: '5px',
                        opacity: disabled ? 0.5 : 1,
                        transition: 'opacity 0.2s ease, background 0.2s ease',
                    }}
                >
                    <Grid item xs={4} sm={8} md={3} textAlign="center" alignItems="center" justifyContent="center" style={{ maxHeight: "80px", height: '80px', width: "80px", maxWidth: "80px" }}>
                        {
                            cardValue.logo.length > 2 ? <>
                                <img src={cardValue.logo} alt="faviconLogo" style={{ height: "80%", width: "80%", textAlign: "center", alignItems: "center", justifyContent: "center", marginTop: "12%" }} />
                            </> : <>
                                <Avatar style={{ textAlign: "center", alignItems: "center", justifyContent: "center", backgroundColor: '#11545A', height: "70%", width: "70%", marginTop: "15%", marginRight: "auto", marginLeft: "auto" }}>{cardValue.logo}</Avatar>
                            </>
                        }
                    </Grid>
                    <Grid item xs={4} sm={8} md={9} textAlign="center" alignItems="center" justifyContent="center" minWidth="265px" >
                        <h5 style={{ color: '#444444' }}>{cardValue?.name}</h5>
                    </Grid>
                </Grid>
            </a>
        </Grid>
    )
}

export default FacturenCard
